import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';

const TitleQuoteDetailStyle = styled('div')`
    ${typography.headingL}
    color: var(--white);

    .edit-title {
        padding: 10px;
        border: 2px solid var(--orange-300);
    }
    .input {
        height: 60px;
        padding: 10px;
        border: 2px solid var(--orange-300);
        font-family: inherit;
        font-size: inherit;
        letter-spacing: inherit;
        color: inherit;
        font-weight: inherit;
        border-radius: 0;
        &.ant-input-status-error {
            border-color: #ff4d4f;
        }
    }
    .max-length {
        color: var(--orange-300);
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        padding: 5px 10px;
        border: 1px solid;
        display: table;
        margin-left: auto;
        margin-top: -30px;
    }

    &.multiple-title {
        color: inherit;
        ${typography.subhead}

        .input {
            height: 46px;
        }

        .max-length {
            margin-top: -12px;
            padding: 0 10px;
        }
    }
`;

export default TitleQuoteDetailStyle;
